<form [formGroup]="loginForm">
  <div class="grid mt-3">
    <div class="col-12">
      <app-input-text [form]="loginForm" icon="person" label="Username" name="username" placeholder=""></app-input-text>
    </div>
    <div class="col-12">
      <app-input-password [form]="loginForm" icon="password" label="Password" name="password"></app-input-password>
    </div>
    <div class="col-12">
      <app-primary-button (click)="onLoginClick()" [disabled]="!loginForm.valid" label="Entra"></app-primary-button>
    </div>
  </div>
</form>
